export default "/images/8ff892d5dc75864e14616b5e89fbb817.avif";